import React from 'react';
import { useSelector } from 'react-redux';
import { makeStyles } from '@material-ui/core';
import cx from 'classnames';

import { useMediaQuery } from 'ha/helpers/MediaQuery';
import { Container, Grid, Paper, units } from '@ha/dsl';

import { SearchFiltersProvider } from 'ha/pages/Search/SearchFiltersProvider';

import SearchMeta from '../containers/SearchMeta';
import SearchMap from './SearchMap.lazy';
import SearchResults from '../containers/SearchResults';
import MobileMap from '../containers/MobileMap';
import SearchResultsLoader from './SearchResultsLoader';
import SearchPageCrawl from './SearchPageCrawl';

import SearchFiltersSidebar from './SearchFilters/SearchFiltersSidebar.lazy';
import SearchOverview from './SearchOverview';
import { getMapViewState } from '../selectors';
import { MapViewState } from '../utils';

const filtersHeightWithLeftPanelFilters = 68;

const useStyles = makeStyles(theme => ({
  suggestionBar: {
    position: 'sticky',
    width: '100%',
    bottom: 0,
    zIndex: 4,
    fallbacks: {
      position: 'fixed',
    },
  },
  mapPaper: {
    position: 'sticky',
    zIndex: 3,
    overflow: 'hidden',
    boxShadow: 'none',
    height: `calc(100vh - ${
      theme.customSpacing.navHeightLg + filtersHeightWithLeftPanelFilters
    }px)`,
    top: `${
      theme.customSpacing.navHeightLg + filtersHeightWithLeftPanelFilters
    }px`,
    boxSizing: 'border-box',
    border: units.border(1, 'solid', theme.palette.grey[300]),
    borderRadius: '4px',
  },
  filters: {
    width: '285px',
    marginRight: '1.5rem',
  },
  width0: {
    maxWidth: 0,
    height: 0,
    overflow: 'hidden',
  },
  listingsContainer: {
    position: 'relative',
  },
}));

export const SearchLayout: React.FC = () => {
  const { md } = useMediaQuery();
  const classes = useStyles();

  const mapViewState = useSelector(getMapViewState);

  return (
    <SearchFiltersProvider instantaneousFiltering>
      <Container
        disableGutters={!md}
        maxWidth={
          md && mapViewState === MapViewState.fullMap ? false : undefined
        }
      >
        <SearchOverview />
        <Grid container wrap="nowrap">
          {md && (
            <div className={classes.filters}>
              <SearchFiltersSidebar />
            </div>
          )}
          <SearchMeta />
          <SearchPageCrawl />

          <Grid container item xs>
            {!(md && mapViewState === MapViewState.fullMap) && (
              <Grid
                container
                direction="column"
                wrap="nowrap"
                item
                md={12}
                className={cx(
                  classes.listingsContainer,
                  mapViewState === MapViewState.fullMap && md && classes.width0,
                )}
                data-test-locator="Search Listings Grid"
              >
                <SearchResultsLoader />
                <SearchResults />
              </Grid>
            )}

            {!md && <MobileMap />}

            {md && mapViewState !== MapViewState.noMap && (
              <Grid item md={12} data-test-locator="Search Listings Map">
                <Paper className={classes.mapPaper}>
                  <SearchMap />
                </Paper>
              </Grid>
            )}
          </Grid>
        </Grid>
      </Container>
    </SearchFiltersProvider>
  );
};

export default SearchLayout;
